"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimWhitespace = void 0;
// Remove extra whitespace generated by ReactDOMServer
var trimWhitespace = function trimWhitespace(rawHtml) {
  return rawHtml.replaceAll(/\r\n|[\t\n\r]/g, '');
};
exports.trimWhitespace = trimWhitespace;